import React, { useContext } from "react"
import { LoadingContext } from "../context/LoadingContext"
import i18n from "i18next"

const ScheduleCall = ({}) => {
  const { windowWidth } = useContext(LoadingContext)

  const handleRegisterButtonClick = () => {
    // Redirigir a la URL proporcionada
    window.location.href =
      "https://www.candidatesexstaff.com.co/"
  }

  return (
    <>
      {windowWidth >= 1025 ? (
        <div className="mobile:w-full desktop:pl-8 desktop:pr-4 mobile:pl-4 mobile:pr-4 flip-card bannerAcademy">
          <div className="flip-card-inner2 contentPopularLocations mt-24 mb-24">
            <div>
              <p className="titleBannerAcademy contentMediaTeams">
                {i18n.t("pageContactUs.ScheduleCallTitle")}
              </p>
              <button
                className="mobile:mt-4 contentButtomMoreAcademy"
                style={{ alignSelf: "center" }}
                onClick={handleRegisterButtonClick}
              >
                <p className="textButtomGetTouch">
                  {i18n.t("pageContactUs.ScheduleCallButton")}
                </p>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="mobile:w-full desktop:pl-8 desktop:pr-4 mobile:pl-4 mobile:pr-4 flip-card bannerAcademyMoblie">
          <div className="flip-card-inner2   mt-20 mb-20">
            <div>
              <p className="titleBannerAcademy ml-6">
                {i18n.t("pageContactUs.ScheduleCallTitle")}
              </p>
              <br></br>
              <button
                className="mobile:mt-4 contentButtomMoreAcademy"
                style={{ alignSelf: "center", width: "90%", margin: "auto" }}
                onClick={handleRegisterButtonClick}
              >
                <p className="textButtonScheduleCall">
                  {i18n.t("pageContactUs.ScheduleCallButton")}
                </p>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ScheduleCall
